import React from 'react';
import { Outlet } from 'react-router-dom';
import { Box, Paper } from '@mui/material';
import { AuthIllustration } from '@/components/auth/AuthIllustration';

export const AuthLayout: React.FC = () => {
  return (
    <Box
      sx={{
        minHeight: '100vh',
        display: 'flex',
        flexDirection: 'row',
      }}
    >
      {/* Left side — Illustration */}
      <Box
        sx={{
          display: { xs: 'none', md: 'flex' },
          width: '65%',
          minHeight: '100vh',
        }}
      >
        <AuthIllustration />
      </Box>

      {/* Right side — Form */}
      <Box
        sx={{
          width: { xs: '100%', md: '35%' },
          minHeight: '100vh',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          backgroundColor: 'background.default',
          p: { xs: 2, sm: 4 },
          overflowY: 'auto',
        }}
      >
        <Paper
          elevation={0}
          sx={{
            width: '100%',
            maxWidth: 440,
            p: { xs: 3, sm: 4 },
            borderRadius: 3,
            backgroundColor: 'background.paper',
            boxShadow: { xs: 3, md: 0 },
          }}
        >
          <Outlet />
        </Paper>
      </Box>
    </Box>
  );
};
